import { render, staticRenderFns } from "./ProdutosFornecedorConfigSubProduto.vue?vue&type=template&id=0ec1dd80"
import script from "./ProdutosFornecedorConfigSubProduto.vue?vue&type=script&lang=js"
export * from "./ProdutosFornecedorConfigSubProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports